import { dateRangeBounds, dateRangeFromPickers, rangeDateValueLabel } from '~/components/AiSearchChips/DateRangeChip/DateRangeChip.utils';
export const DISCOUNT_EXPIRATION_DATE_OPTION = 'date';
export const discountExpirationDateBounds = (date)=>dateRangeBounds(date);
export const discountExpirationDateLabel = (date, t)=>rangeDateValueLabel(date, t.servicesDiscountExpirationDateLabel());
export const discountExpirationDateFromRadio = (param)=>{
    let { selected, from, to } = param;
    if (selected !== DISCOUNT_EXPIRATION_DATE_OPTION) return undefined;
    return dateRangeFromPickers({
        from,
        to
    });
};
